import { IResponse } from '@microsoft/portal-app/lib/ajax-utils';
import { createAjaxEpic } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import { map } from 'rxjs/operators';
import { getLinkedInStatusApiUrl } from '../../../redux/modules/accountApis';
import { IPrivacyAction } from '../../models/IPrivacyActions';
import { IPrivacyState } from '../../models/IPrivacyState';
import { IService } from '../../models/IService';
import { LinkedInStatus } from '../../models/LinkedInStatusEnum';
import { PrivacyActions } from '../../models/PrivacyActions';
import { privacyRegistry as registry } from '../privacyRegistry';

export const linkedInServiceId = 'linkedInService';

export const linkedInServiceName = 'LinkedIn';

export const linkedInHelpText = {
  key: 'Learn about the shared data and how to manage it',
  options: [''],
};

export const linkedInHelpLink = 'https://go.microsoft.com/fwlink/?linkid=870120';

export const linkedInDescription = {
  key:
    "You've given permissions to share data from your work or school account with your LinkedIn account." +
    ' ' +
    "To stop data sharing, select 'Revoke these permissions'." +
    ' ' +
    'Note that when you remove the permissions, not all your shared data is automatically deleted.' +
    ' ' +
    "If you've also given premission to share data from your LinkedIn account to your work or school account, " +
    'you can remove these permissions from your LinkedIn settings.',
  options: [''],
};

export const linkedInRevokeText = {
  key: 'Revoke these permissions',
  options: [''],
};
export const getLinkedInStatus = (ajax: AjaxCreationMethod) =>
  ajax({
    method: 'GET',
    ...getLinkedInStatusApiUrl(),
  }).pipe(map((payload: IResponse<LinkedInStatus>) => payload.response));

registry.addEpic(PrivacyActions.getLinkedInStatus, createAjaxEpic(PrivacyActions.getLinkedInStatus, getLinkedInStatus));

export const getLinkedInStatusResponse = (
  state: IPrivacyState,
  action: IPrivacyAction<{ value: LinkedInStatus }>,
): IPrivacyState => {
  const status = action.payload && action.payload.value;
  if (!action.payload || (status !== LinkedInStatus.Bound && status !== LinkedInStatus.MicrosoftBound)) {
    return state;
  }

  const nextState: IPrivacyState = {
    ...state,
    linkedInService: {
      serviceName: linkedInServiceName,
      serviceId: linkedInServiceId,
      enabled: true,
      localizedDescription: linkedInDescription,
      localizedRevokeText: linkedInRevokeText,
      revokeAction: 'revokeLinkedIn',
      helpLinkHref: linkedInHelpLink,
      localizedHelpText: linkedInHelpText,
    } as IService,
  };

  return nextState;
};

registry.add(PrivacyActions.getLinkedInStatusResponse, getLinkedInStatusResponse);
